<template>
  <v-app class="futuristic-app">

    <v-app-bar app flat height="74" class="layanan-header">
      <div class="header-inner">
        <v-btn icon class="back-btn" @click="$router.back()" aria-label="Kembali">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <div class="header-brand">
          <div class="brand-mark">
            <img src="/images/icon2.png" width="40" />
          </div>

          <div class="brand-copy">
            <div class="brand-name">BONDOWOSO <span>BERKAH</span></div>
            <div class="brand-tagline">Berkualitas, Akseleratif dan Holistik</div>
          </div>
        </div>

        <v-spacer />

        <div class="header-info d-none d-sm-flex">
          <div class="header-info-icon">
            <v-icon size="18" color="#018c74"> mdi-map-marker-check-outline </v-icon>
          </div>

          <div>
            <div class="header-info-title">Titik Kumpul Evakuasi</div>
            <div class="header-info-subtitle">{{ filteredList.length }} lokasi</div>
          </div>
        </div>
      </div>
    </v-app-bar>

    <v-main class="main-area">
      <v-container fluid class="px-6 fill-height align-start">
        <v-row class="fill-height mt-2" no-gutters>
          <v-col cols="12" md="8" class="pr-md-3 fill-height">
            <v-card class="cyber-map-container overflow-hidden full-height-card">
              <div class="map-corners">
                <div class="c-tl"></div>
                <div class="c-tr"></div>
                <div class="c-bl"></div>
                <div class="c-br"></div>
              </div>
              <div id="map"></div>
            </v-card>
          </v-col>

          <v-col
            cols="12"
            md="4"
            class="pl-md-3 fill-height d-flex flex-column"
            style="max-height: calc(100vh - 140px)"
          >
            <v-card
              class="panel-right pa-4 flex-grow-1 d-flex flex-column overflow-hidden"
            >
              <div class="px-2 mb-4">
                <div class="gold--text overline mb-2">Cari Lokasi</div>
                <v-text-field
                  v-model="searchQuery"
                  placeholder="Cari Desa atau Kecamatan..."
                  filled
                  rounded
                  dense
                  hide-details
                  prepend-inner-icon="mdi-magnify"
                  color="#018c74"
                  background-color="rgba(255, 255, 255, 0.8)"
                  class="cyber-search"
                ></v-text-field>
              </div>

              <div class="gold--text overline mb-2 px-2">Daftar Area Penyelamatan</div>

              <div
                class="flex-grow-1 overflow-y-auto custom-scrollbar px-2"
                ref="listContainer"
              >
                <v-card
                  v-for="item in filteredList"
                  :key="item.id"
                  :id="'item-' + item.id"
                  @click="focusToLocation(item)"
                  :class="[
                    'item-list-evakuasi mb-3 pa-4 rounded-lg',
                    selectedId === item.id ? 'active-item' : '',
                  ]"
                >
                  <div class="d-flex align-center">
                    <div class="icon-box mr-4">
                      <v-icon :color="selectedId === item.id ? 'black' : '#018c74'"
                        >mdi-run-fast</v-icon
                      >
                    </div>
                    <div>
                      <div class="black--text font-weight-bold text-subtitle-1">
                        {{ item.desa }}
                      </div>
                      <div class="gold--text caption">{{ item.nama_kecamatan }}</div>
                    </div>
                  </div>
                  <v-divider class="rgba-white-1 my-3"></v-divider>
                  <div class="d-flex align-center">
                    <v-icon x-small color="grey" class="mr-2"
                      >mdi-office-building-marker</v-icon
                    >
                    <span class="grey--text caption">{{ item.deskripsi }}</span>
                  </div>
                </v-card>
              </div>

              <v-btn
                v-if="selectedId"
                block
                large
                color="#018c74"
                class="mt-4 rounded-xl white--text font-weight-bold animate-fade-in"
                @click="openGmaps"
              >
                <v-icon left>mdi-navigation-variant</v-icon> Petunjuk Arah
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { getTitikKumpulBencana } from "@/api/androidInitApi";

export default {
  data: () => ({
    map: null,
    listTitik: [],
    searchQuery: "",
    selectedId: null,
    selectedCoords: null,
    markersLayer: null,
    markerObjects: {},
  }),
  computed: {
    filteredList() {
      if (!this.searchQuery) return this.listTitik;
      const q = this.searchQuery.toLowerCase();
      return this.listTitik.filter(
        (item) =>
          item.desa.toLowerCase().includes(q) ||
          item.nama_kecamatan.toLowerCase().includes(q)
      );
    },
  },
  async mounted() {
    this.initMap();
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        this.listTitik = (await getTitikKumpulBencana()) || [];
        this.renderMarkers();
      } catch (e) {
        console.error(e);
      }
    },
    initMap() {
      this.map = L.map("map", { zoomControl: false, attributionControl: false }).setView(
        [-7.9135, 113.8217],
        11
      );
      L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap contributors",
      }).addTo(this.map);
      this.markersLayer = L.layerGroup().addTo(this.map);
      this.loadMasking();
    },
    async loadMasking() {
      try {
        const res = await fetch("/images/35.11_kecamatan.geojson");
        const geoData = await res.json();
        const world = [
          [
            [-90, -180],
            [-90, 180],
            [90, 180],
            [90, -180],
            [-90, -180],
          ],
        ];
        geoData.features.forEach((f) => {
          if (f.geometry.type === "Polygon")
            world.push(f.geometry.coordinates[0].map((c) => [c[1], c[0]]));
          else
            f.geometry.coordinates.forEach((p) =>
              world.push(p[0].map((c) => [c[1], c[0]]))
            );
        });
        L.polygon(world, {
          color: "black",
          weight: 0,
          fillColor: "#000",
          fillOpacity: 0.9,
          interactive: false,
        }).addTo(this.map);
        L.geoJson(geoData, {
          style: { color: "#018c74", weight: 1.5, fillColor: "transparent" },
          onEachFeature: (feature, layer) => {
            if (feature.properties && feature.properties.NAMOBJ) {
              const labelIcon = L.divIcon({
                className: "kecamatan-label",
                html: `<span>${feature.properties.NAMOBJ}</span>`,
                iconSize: [100, 20],
              });
              L.marker(layer.getBounds().getCenter(), {
                icon: labelIcon,
                interactive: false,
              }).addTo(this.map);
            }
          },
        }).addTo(this.map);
      } catch (e) {
        console.error(e);
      }
    },
    renderMarkers() {
      this.markersLayer.clearLayers();
      this.listTitik.forEach((item) => {
        if (!item.koordinat) return;
        const coords = item.koordinat.split(",").map((c) => parseFloat(c.trim()));

        const icon = L.divIcon({
          className: "evakuasi-marker",
          html: `<div class="safe-pulse"></div><div class="safe-icon"><i class="v-icon mdi mdi-shield-check black--text" style="font-size: 18px;"></i></div>`,
          iconSize: [50, 50],
          iconAnchor: [25, 25],
        });

        const marker = L.marker(coords, { icon }).addTo(this.markersLayer);

        const popupContent = `
          <div class="custom-popup">
            <div class="popup-title">${item.desa}</div>
            <div class="popup-sub">${item.nama_kecamatan}</div>
            <hr class="popup-divider">
            <div class="popup-desc"><i class="mdi mdi-map-marker"></i> ${item.deskripsi}</div>
          </div>
        `;
        marker.bindPopup(popupContent, { closeButton: false, offset: [0, -10] });

        marker.on("click", () => {
          this.focusToLocation(item, false);
        });

        this.markerObjects[item.id] = marker;
      });
    },
    focusToLocation(item, triggerPopup = true) {
      this.selectedId = item.id;
      this.selectedCoords = item.koordinat;
      const coords = item.koordinat.split(",").map((c) => parseFloat(c.trim()));

      this.map.flyTo(coords, 15, { duration: 1.5 });

      if (triggerPopup && this.markerObjects[item.id]) {
        this.markerObjects[item.id].openPopup();
      }

      this.$nextTick(() => {
        const el = document.getElementById("item-" + item.id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    },
    openGmaps() {
      if (this.selectedCoords) {
        window.open(
          `https://www.google.com/maps/dir/?api=1&destination=${this.selectedCoords.replace(
            /\s+/g,
            ""
          )}`,
          "_blank"
        );
      }
    },
  },
};
</script>


<style scoped>
:root {
  --bg-teal: #018c74;
  --bg-teal-dark: #016b62;
  --bg-teal-light: #8bcdc6;
  --bone-white: #f5f5f5;
  --bone-light: #fafafa;
  --text-primary: #2e2e2e;
  --accent-gold: #ffa726;
  --accent-teal: #018c74;
}

.full-height-card {
  height: calc(100vh - 140px);
  border-radius: 24px !important;
}
#map {
  height: 100%;
  width: 100%;
  background: var(--bg-teal-dark);
}



.cyber-map-container {
  border: 1px solid rgba(45, 138, 122, 0.35) !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2) !important;
  border-radius: 20px;
}
.panel-right {
  background: #f5f5f5 !important;
  backdrop-filter: blur(20px);
  border-radius: 24px !important;
  border: 1px solid rgba(45, 138, 122, 0.25) !important;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.15);
  color: var(--text-primary) !important;
}

.cyber-search :deep(.v-input__slot) {
  background: #f5f5f5 !important;
  border: 1px solid rgba(45, 138, 122, 0.3);
  border-radius: 12px !important;
}
.item-list-evakuasi {
  background: var(--bone-white);
  border: 1px solid rgba(45, 138, 122, 0.2);
  cursor: pointer;
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}
.item-list-evakuasi:hover {
  box-shadow: 0 8px 32px rgba(45, 138, 122, 0.2);
  transform: translateY(-2px);
}
.active-item {
  background: rgba(45, 138, 122, 0.15) !important;
  border: 1px solid var(--accent-teal) !important;
  box-shadow: 0 8px 24px rgba(38, 166, 154, 0.3);
}

:deep(.leaflet-popup-content-wrapper) {
  background: var(--bone-white) !important;
  backdrop-filter: blur(15px);
  color: var(--text-primary) !important;
  border: 1px solid rgba(45, 138, 122, 0.35);
  border-radius: 12px;
  padding: 8px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.25);
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
}
:deep(.leaflet-popup-tip) {
  background: rgba(45, 138, 122, 0.4) !important;
}
:deep(.custom-popup) {
  text-align: center;
  min-width: 150px;
}
:deep(.popup-title) {
  font-weight: 900;
  text-transform: uppercase;
  font-size: 14px;
  color: var(--text-primary);
  margin-bottom: 4px;
}
:deep(.popup-sub) {
  color: var(--accent-gold);
  font-size: 11px;
  font-weight: 700;
  margin-bottom: 6px;
}
:deep(.popup-divider) {
  border: 0;
  border-top: 1px solid rgba(45, 138, 122, 0.3);
  margin: 8px 0;
}
:deep(.popup-desc) {
  font-size: 12px;
  color: var(--text-primary);
  font-weight: 500;
}

:deep(.evakuasi-marker) {
  display: flex;
  align-items: center;
  justify-content: center;
}
:deep(.safe-icon) {
  width: 34px;
  height: 34px;
  background: var(--accent-teal);
  border: 3px solid var(--bone-white);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 25px rgba(38, 166, 154, 0.6);
}
:deep(.safe-pulse) {
  position: absolute;
  width: 70px;
  height: 70px;
  background: rgba(38, 166, 154, 0.4);
  border-radius: 50%;
  animation: pulse-safe 2.5s infinite;
}
@keyframes pulse-safe {
  0% {
    transform: scale(0.3);
    opacity: 0.8;
  }
  100% {
    transform: scale(1.6);
    opacity: 0;
  }
}

:deep(.kecamatan-label span) {
  color: var(--bone-white);
  font-size: 8px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  text-shadow: 0 0 6px rgba(0, 0, 0, 0.9);
}

.map-corners div {
  position: absolute;
  width: 30px;
  height: 30px;
  border: 3px solid var(--accent-gold);
  z-index: 10;
  pointer-events: none;
}
.c-tl {
  top: 15px;
  left: 15px;
  border-right: 0;
  border-bottom: 0;
}
.c-tr {
  top: 15px;
  right: 15px;
  border-left: 0;
  border-bottom: 0;
}
.c-bl {
  bottom: 15px;
  left: 15px;
  border-right: 0;
  border-top: 0;
}
.c-br {
  bottom: 15px;
  right: 15px;
  border-left: 0;
  border-top: 0;
}

.gold--text {
  color: var(--accent-gold) !important;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 4px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: var(--accent-teal);
  border-radius: 10px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: var(--accent-gold);
}

@media (max-width: 768px) {
  .map-corners div {
    width: 24px;
    height: 24px;
    border-width: 2px;
  }
  :deep(.safe-icon) {
    width: 28px;
    height: 28px;
  }}


.futuristic-app {
  background: #f6f9f9 !important;
}

.main-area {
  background: radial-gradient(circle at 90% 5%, rgba(1, 140, 116, 0.035), transparent 25%),
    #f6f9f9;
}

.layanan-header {
  background: rgba(255, 255, 255, 0.94) !important;

  backdrop-filter: blur(18px);

  border-bottom: 1px solid rgba(1, 140, 116, 0.08) !important;

  z-index: 20 !important;
}

.header-inner {
  width: 100%;
  max-width: 1280px;

  margin: 0 auto;

  display: flex;
  align-items: center;
}

.back-btn {
  width: 42px !important;
  height: 42px !important;

  background: #f1f6f5;
  margin-right: 10px;
}

.back-btn:hover {
  background: #e8f5f2;
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-mark {
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 12px;

  background: linear-gradient(135deg, #e4f6f1, #f5fbf9);

  border: 1px solid rgba(1, 140, 116, 0.1);
}

.brand-name {
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 0.5px;
  color: #17423b;
  line-height: 1.1;
}

.brand-name span {
  color: #018c74;
}

.brand-tagline {
  font-size: 9px;
  color: #8a969b;
  margin-top: 3px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}

.header-info > div:last-child {
  min-width: 0;
}

.header-info-icon {
  width: 36px;
  height: 36px;

  border-radius: 10px;

  background: #f1faf8;

  display: flex;
  align-items: center;
  justify-content: center;
}

.header-info-title {
  font-size: 12px;
  font-weight: 800;
  color: #34514c;
}

.header-info-subtitle {
  max-width: 260px;

  font-size: 10px;
  color: #929da1;
  margin-top: 1px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-search {
  max-width: 300px;
}

.header-search-wrap {
  min-width: 0;
}

.header-search ::v-deep .v-input__slot,
.cyber-search-dropdown ::v-deep .v-input__slot {
  min-height: 42px !important;

  background: #f1f6f5 !important;

  border: 1px solid rgba(1, 140, 116, 0.12) !important;

  box-shadow: none !important;

  transition: all 0.25s ease;
}

.header-search ::v-deep .v-input__slot:focus-within,
.cyber-search-dropdown ::v-deep .v-input__slot:focus-within {
  background: #ffffff !important;

  border-color: #018c74 !important;
}

.header-search ::v-deep .v-icon,
.cyber-search-dropdown ::v-deep .v-icon {
  color: #018c74;
}

@media (max-width: 600px) {
  .header-inner {
    padding: 0 8px;
  }

  .brand-mark {
    width: 35px;
    height: 35px;
  }

  .brand-name {
    font-size: 12px;
  }

  .brand-tagline {
    font-size: 8px;
  }
}
</style>
